import React from 'react';
import { Spin, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import usePPAChanneld from 'hooks/usePPAChanneld';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import useAdStatus from 'hooks/marketing/useAdStatus';
import { EPPAStep } from 'types/ppaOnboarding';
import { EInvitedProviderStep } from 'pages/InvitedProviderOnboarding/steps';
import HealthBg from 'assets/marketing/health-bg.png';
import s from '../KlarityMarketing/s.module.less';
import StandardListingTable from '../StandardListingTable/index';
import PerformanceCard from '../Performance';

type Props = {
    onSetupClick: () => void;
    isReadOnly: boolean;
    isOwner: boolean;
};

const SoloPerformance: React.FC<Props> = ({ onSetupClick, isReadOnly, isOwner }) => {
    const navigate = useNavigate();
    const [ppaId] = usePPAChanneld(true);
    const [homeInfo] = useProviderHomeInfo();
    const [adStatus, adStatusLoading] = useAdStatus();

    const isPPAProvider = homeInfo?.ppaProvider;
    const joinKlarityHealth = !!homeInfo?.klarityListed || homeInfo?.klarityOnboardingStep === EPPAStep.STEP_21 || homeInfo?.klarityOnboardingStep === EInvitedProviderStep.COMPLETED;

    return (
        <>
            {isPPAProvider && !joinKlarityHealth && isOwner && (
                <div className={s.card}>
                    <div className={s.cardContent}>
                        <div className={s.leftSection}>
                            <div className={s.textSection}>
                                <h2 className={s.title}>
                                    Grow your practice with <span className={s.highlight}>Klarity Health</span>
                                </h2>
                                <p className={s.description}>
                                    Opt into Klarity Health for free to attract more patients. You only need to pay when
                                    there is an appointment scheduled on your calendar.
                                </p>
                                <Button
                                    type="primary"
                                    className={s.startButton}
                                    onClick={() => {
                                        navigate(`${PATH.DASHBOARD}/${PATH.CHANNEL_DETAIL}?channelId=${ppaId}`);
                                    }}
                                >
                                    Join now
                                </Button>
                            </div>
                        </div>
                        <div className={s.rightSection}>
                            <img src={HealthBg} alt="health" />
                        </div>
                    </div>
                </div>
            )}
            {isPPAProvider && joinKlarityHealth && (
                <div className={s.healthChannel}>
                    <div className={s.header}>
                        <div className={s.title}>Standard listing</div>
                    </div>
                    <StandardListingTable ppaChannelId={Number(ppaId)} />
                </div>
            )}

            <Spin spinning={adStatusLoading}>
                <PerformanceCard
                    hasJoinedAdSystem={adStatus.hasJoinedAdSystem}
                    joinedAt={adStatus.joinedAt}
                    onSetupClick={onSetupClick}
                    isReadOnly={isReadOnly}
                />
            </Spin>
        </>
    );
};

export default SoloPerformance;
